import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const API_URL = `https://apii.digically.in/api/contacts/inquiries/`;


const authHeader = () => {
const token = localStorage.getItem("access");
return token ? { Authorization: `Bearer ${token}` } : {};
};


/* ================= FETCH INQUIRIES ================= */
export const fetchInquiries = createAsyncThunk(
"contacts/fetchInquiries",
async (_, { rejectWithValue }) => {
try {
const res = await axios.get(API_URL, { headers: authHeader() });
return res.data.results || res.data; // supports paginated & non-paginated
} catch (err) {
    return rejectWithValue("Failed to fetch inquiries");
}
}
);


/* ================= DELETE INQUIRY ================= */
export const deleteInquiry = createAsyncThunk(
"contacts/deleteInquiry",
async (id, { rejectWithValue }) => {
try {
await axios.delete(`${API_URL}${id}/`, { headers: authHeader() });
return id;
} catch (err) {
return rejectWithValue("Failed to delete inquiry");
}
}
);


const contactSlice = createSlice({
    name: "contacts",
initialState: { items: [], loading: false, error: null },
reducers: {},
extraReducers: (builder) => {
builder
.addCase(fetchInquiries.pending, (state) => { state.loading = true; state.error = null; })
.addCase(fetchInquiries.fulfilled, (state, action) => { state.loading = false; state.items = action.payload; })
.addCase(fetchInquiries.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
.addCase(deleteInquiry.fulfilled, (state, action) => {
state.items = state.items.filter((i) => i.id !== action.payload);
});
},
});


export default contactSlice.reducer;